@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.linkInputRoot {
  &.hasSources {
    margin-top: 32px;
  }
}

.inputLabel {
  @include typography-v2-body-sm;
  margin-bottom: 4px;
}

.styledButton {
  position: absolute;
  bottom: 9px;
  right: 12px;
  background-color: var(--surface-default);

  &:disabled {
    border: none;
    background-color: var(--surface-default);
  }
}

.inputWrapper {
  position: relative;
}

.textareaElement {
  flex: 1;
  background-color: transparent;
  caret-color: var(--text-primary);
  -moz-appearance: textfield;
  color: var(--text-default);

  &:active,
  &:hover:not(:focus),
  &:focus-within {
    outline: none;
  }

  &::placeholder {
    color: var(--text-soft);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  padding: 8px 12px;
  border: 1px solid var(--border-default);
  width: 100%;
  @include border-radius-r1;
  @include custom-scroll-minimal;
  @include typography-v2-body-base;
  max-height: 240px;
  resize: none;

  &:hover {
    border: 1px solid var(--border-hover);
  }

  &:focus {
    border: 1px solid var(--border-primary);
  }
}
